module.exports = __webpack_public_path__ + "img/facetes.97b45e7.webp";